import Controller from '@ember/controller';

export default class LoginController extends Controller {
  // keep in sync with /constants.js and register controller
  publicIdEmailParams = ['gpId', 'epId', 'ppId', 'upId'];

  queryParams = ['email', 'next'].concat(this.publicIdEmailParams);
  email = null; // email can be passed to be prefilled
  next = null; // next url to redirect after login
  gpId = null;
  epId = null;
  ppId = null;
  upId = null;
}
